import React, { useEffect, useState } from 'react';
import p_nav_previous from '../../../Assets/Images/p_nav_previous.svg';
import wallet_banner from '../../../Assets/Images/wallet_banner.png';
import point_icons from '../../../Assets/Images/ping_coin.png';
import "./wallet.css";
import { FaPlus } from "react-icons/fa6";
import { MdOutlineArrowForwardIos } from "react-icons/md";

import { useNavigate } from 'react-router-dom';
import { showToast } from '../../../Components/toastConfig/ToastConfig';
import NodeaxiosInstance from '../../../Services/nodeaxios';
import WalletTransactionCard from '../../../Components/cards/walletTransactionCard';

const VendorsTokensList = () => {

    const navigate = useNavigate();
    const [fil_type, set_fil_type] = useState(1);
    const [vendorTokens, setVendorTokens] = useState([]);
    const [vendorTokensRawData, setVendorTokensRawData] = useState([]);

    useEffect(() => {
        fetchVendorTokens()
    }, [])

    const fetchVendorTokens = async () => {
        try {
            let respones = await NodeaxiosInstance.get("/wallet/shared-pings");
            if (respones.status == 200) {
                console.log("wallet- shared-pings", respones.data);
                setVendorTokens(respones?.data?.rewards?.slice(0, 3) || []);
            }
        } catch (error) {
            console.error("Error fetching wallet-shared-pings data:", error);
            showToast("Failed to fetch wallet shared pings. Please try again later.");
        }
    } 
  

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  offcanvas-parentType1">
                <div className="d-flex justify-content-between align-items-center  " onClick={() => navigate(-1)}>
                    <img src={p_nav_previous} alt="Previous Button" role="button" width={'24px'} height={'16px'} />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>History</div>
                </div>
            </div>
            <div className="px-3 py-1  bg-white d-flex flex-column" style={{ height: "calc(100dvh - 62px)" }}>
                {/* <div className="wallet_history_search_container">
                    <div className="wallet_history_searchOptionsList">
                        {tabList?.map((item) => (
                            <div key={item.id} className={`wallet_history_search_option  ${fil_type == item.id ? "active primary-text" : ""}`} role="button"
                                onClick={() => { filterTransactions(item.id); set_fil_type(item.id); }}  >
                                {item?.name}
                            </div>
                        ))}
                    </div>
                </div> */}

                {/* <div className=" ">
                    <input type="text" className="wallet_history_search_input" placeholder="Search by vendor or hub name" onChange={(e) => {
                        const searchTerm = e.target.value.toLowerCase();
                        const filteredTransactions = transactionHistoryRawData.filter(transaction => {
                            const vendorName = transaction.vendor_company_name?.toLowerCase() || '';
                            const hubName = transaction.hub_name?.toLowerCase() || '';
                            return vendorName.includes(searchTerm) || hubName.includes(searchTerm);
                        });
                        setTransactionHistory(filteredTransactions);
                    }} />
                </div> */}


                <div className="scroller-style-y pb-5 flex-grow-1">
                    <div>
                        {
                         vendorTokens.map((item, index) => (
                            <div key={item.vendor_id || index} className='vendor_wallet_box'>

                                <div className='d-flex justify-content-between w-100 vendor_info'   >
                                    <div className='d-flex justify-content-between'>
                                        <img
                                            src={item?.vendor_logo || 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/68edda1b86009.png'}
                                            alt="Vendor Logo"
                                            className='vendor_logo'
                                        />

                                        <div className='ms-2 '>
                                            <p className='vendor_token_vendor_name'>
                                                {item?.vendor_company_name || 'Chop chop'}
                                                {item?.hub_name && <span className='vendor_token_hub_name'> ({item?.hub_name}) </span>}
                                            </p>
                                            <p className='vendor_ping_point'>
                                                {item?.balance || 100} Tokens
                                            </p> 

                                        </div>
                                    </div>

                                    {/* <span className='d-flex justify-content-center align-items-center'> */}
                                    <button className='ping_redeem_btn mt-4' onClick={() => {
                                        localStorage.setItem('payType', 'tokenredeem')
                                        navigate(`/vendor/${item?.vendor_id}`)
                                    }
                                    }> Redeem <MdOutlineArrowForwardIos className='ms-2' /> </button>
                                    {/* </span> */}
                                </div>
                            </div>
                        ))
                        
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default VendorsTokensList;

